import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { environment } from "../config/environment";

 
let stompClient = null;
const token = localStorage.getItem("token");
 
export const connectWebSocket = (userId, onMessageReceived) => {
 
const socket = new SockJS(`${environment.apiUrl}/ws-notifications?userId=${userId}`);
 
  stompClient = new Client({
    webSocketFactory: () => socket,
 
    debug: (str) => console.log(str),
 
    reconnectDelay: 5000,
 
   
    onConnect: () => {
      console.log("Connected to WebSocket via Gateway");
 
      stompClient.subscribe("/user/queue/notifications", (message) => {
        console.log("Notification received:", message.body);
 
        if (message.body) {
          try {
            const parsedMessage = JSON.parse(message.body);
            onMessageReceived(parsedMessage);
          } catch (error) {
            console.error("Error parsing message:", error);
          }
        }
      });
    },
 
    onStompError: (frame) => {
      console.error("STOMP error:", frame.headers["message"]);
      console.error("Details:", frame.body);
    },
 
    onWebSocketError: (error) => {
      console.error("WebSocket error:", error);
    }
  });
 
  stompClient.activate();
};
 
 
export const disconnectWebSocket = () => {
  if (stompClient) {
    stompClient.deactivate();
    console.log("WebSocket disconnected");
  }
};
 